import moment from 'moment-timezone';

const userTimezoneSaved = localStorage.getItem('face-lift-user-time-zone');
class UserDate {
  static userTimezone = userTimezoneSaved ? userTimezoneSaved : Intl.DateTimeFormat().resolvedOptions().timeZone;
  constructor(time) {
    this.time = time;
  }
  setUserTimezone(timezone) {
    if (timezone) {
      localStorage.setItem('face-lift-user-time-zone', timezone);
      UserDate.userTimezone = timezone;
    }
  }
  getTime() {
    return this.time;
  }
}

export { UserDate };
